<template>
  <div
    tabindex="0"
    @keyup.esc="$emit('close')"
    class="fixed w-full overflow-hidden border-l border-[#dedede] dark:border-[#353843] py-8 outline-none"
  >
    <div
      class="absolute filter blur-3xl opacity-50 mix-blend-multiply top-12 left-[60px] bg-indigo-700 w-32 h-32 rounded-full"
    ></div>
    <div
      class="absolute filter blur-3xl opacity-30 mix-blend-multiply top-1/2 left-1/2 bg-fire w-[200px] h-[200px] rounded-full"
    ></div>
    <div class="z-10 flow-root w-full">
      <div class="w-full">
        <h2
          class="flex flex-row space-x-4 dark:text-white text-[28px] font-medium items-center"
        >
          <span>
            <svg
              class=""
              width="20.022"
              height="23.555"
              viewBox="0 0 20.022 23.555"
            >
              <defs>
                <linearGradient
                  id="linear-gradient"
                  x1="-0.441"
                  y1="0.5"
                  x2="1.376"
                  y2="0.5"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stop-color="#ed1b24" />
                  <stop offset="1" stop-color="#f97643" />
                </linearGradient>
              </defs>
              <g
                id="Group_1322"
                data-name="Group 1322"
                transform="translate(-974 -70.944)"
              >
                <g transform="translate(974 70.944)">
                  <g data-name="Paper Download">
                    <path
                      data-name="Paper Download"
                      d="M5.5,23.555A5.533,5.533,0,0,1,0,18.008V5.312A5.292,5.292,0,0,1,5.259,0h6.228a.546.546,0,0,1,.536.542V4.334a3.935,3.935,0,0,0,3.9,3.934c.493,0,.931,0,1.318.007.3,0,.565,0,.793,0,.166,0,.381,0,.614-.005.269,0,.572-.006.844-.006a.528.528,0,0,1,.536.53v9.469a5.274,5.274,0,0,1-5.248,5.288Zm.128-10.941a.889.889,0,0,0,0,1.249l3.335,3.38a.919.919,0,0,0,.28.188.819.819,0,0,0,.338.071.758.758,0,0,0,.326-.071.919.919,0,0,0,.28-.188l3.346-3.38a.88.88,0,0,0-.012-1.249.859.859,0,0,0-1.224,0L10.448,14.5V8.821a.864.864,0,0,0-.863-.883.88.88,0,0,0-.875.883V14.5L6.857,12.614a.859.859,0,0,0-1.224,0ZM16.068,6.548a2.376,2.376,0,0,1-2.352-2.375v-3.1a.556.556,0,0,1,.957-.393l4.7,4.931a.562.562,0,0,1-.4.951h-.759C17.454,6.557,16.673,6.554,16.068,6.548Z"
                      fill="url(#linear-gradient)"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span class="tracking-wide">{{ t("application.documents") }}</span>
        </h2>
        <p
          class="text-navada py-2 text-base text-[14px] text-navada dark:text-[#7f8a9e]"
        >
          {{ t("application.process") }}
        </p>
        <div class="w-full h-[1px] bg-[#cbced2] dark:bg-[#353843] mt-6"></div>
      </div>
      <div class="overflow-y-auto h-all-q">
        <h2 class="mt-6 text-xl font-bold dark:text-white">
          {{ t("input.uploadedd") }}
        </h2>
        <ul
          role="list"
          class="py-2 pr-4 space-y-4 overflow-x-hidden overflow-y-auto"
        >
          <li
            v-for="(item, idx) in items"
            :key="idx"
            class="w-full rounded-[12px] px-0 py-2 sm:flex flex-col sm:items-start sm:justify-between"
          >
            <div
              class="flex w-full items-center shadow-sm rounded-[12px] dark:bg-[#2e2d38] bg-white min-h-[70px]"
            >
              <div class="flex items-center justify-center px-4">
                <span
                  class="inline-flex justify-center items-center w-[40px] h-[40px] rounded-full dark:bg-[#363640] bg-[#f7f7f8]"
                >
                  <svg
                    class="hidden dark:block w-5 h-5 fill-current text-[#2d283f] dark:text-red-500"
                    viewBox="0 0 21 21"
                  >
                    <g transform="translate(0.7 0.7)">
                      <g>
                        <g>
                          <g>
                            <path
                              d="M15.855,0a.7.7,0,0,0-.616.364A6.3,6.3,0,0,1,9.8,3.485,6.3,6.3,0,0,1,4.361.364.7.7,0,0,0,3.745,0H.7A.7.7,0,0,0,0,.7V5.6a.7.7,0,0,0,.7.7H18.9a.7.7,0,0,0,.7-.7V.7a.7.7,0,0,0-.7-.7Z"
                              transform="translate(0 13.3)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M0,13.3V0H15.4V13.3"
                              transform="translate(2.1)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-3"
                              data-name="Path"
                              d="M0,.533H4.2"
                              transform="translate(5.6 3.667)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-4"
                              data-name="Path"
                              d="M0,.533H8.4"
                              transform="translate(5.6 6.467)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-5"
                              data-name="Path"
                              d="M0,.533H8.4"
                              transform="translate(5.6 9.267)"
                              fill="none"
                              stroke="#fff"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <svg
                    class="dark:hidden w-5 h-5 fill-current text-[#2d283f] dark:text-red-500"
                    viewBox="0 0 21 21"
                  >
                    <g transform="translate(0.7 0.7)">
                      <g>
                        <g>
                          <g>
                            <path
                              d="M15.855,0a.7.7,0,0,0-.616.364A6.3,6.3,0,0,1,9.8,3.485,6.3,6.3,0,0,1,4.361.364.7.7,0,0,0,3.745,0H.7A.7.7,0,0,0,0,.7V5.6a.7.7,0,0,0,.7.7H18.9a.7.7,0,0,0,.7-.7V.7a.7.7,0,0,0-.7-.7Z"
                              transform="translate(0 13.3)"
                              fill="none"
                              stroke="#2c293d"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M0,13.3V0H15.4V13.3"
                              transform="translate(2.1)"
                              fill="none"
                              stroke="#2c293d"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-3"
                              data-name="Path"
                              d="M0,.533H4.2"
                              transform="translate(5.6 3.667)"
                              fill="none"
                              stroke="#2c293d"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-4"
                              data-name="Path"
                              d="M0,.533H8.4"
                              transform="translate(5.6 6.467)"
                              fill="none"
                              stroke="#2c293d"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Path-5"
                              data-name="Path"
                              d="M0,.533H8.4"
                              transform="translate(5.6 9.267)"
                              fill="none"
                              stroke="#2c293d"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
              <div
                class="flex items-center justify-between flex-1 truncate rounded-r-md"
              >
                <div class="flex-1 px-4 py-2 text-sm truncate">
                  <a
                    class="dark:text-white text-lg text-[#2d2740] font-medium hover:text-mute"
                    >{{ item[0].display }}</a
                  >
                </div>
                <div class="flex-shrink-0 pr-4 space-x-2">
                  <button
                    @click="showFile(item)"
                    type="button"
                    class="inline-flex items-center justify-center p-2 border border-transparent rounded-full text-white bg-gradient-to-b from-[#ff000e] via-[#ff241d] to-[#ff602b] dark:bg-gray-600 hover:bg-gray-700"
                  >
                    <MinusIcon
                      v-if="show && currentItem[0].name === item[0].name"
                      class="w-4 h-4"
                      aria-hidden="true"
                    />
                    <PlusIcon v-else class="w-4 h-4" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
            <TransitionRoot
              :show="show && currentItem[0].name === item[0].name"
              as="div"
              enter="transition transform ease-out duration-300"
              enter-from="opacity-0 -translate-y-1/2"
              enter-to="opacity-100 translate-y-0"
              leave="transition transform ease-in duration-400"
              leave-from="opacity-100 translate-y-0"
              leave-to="opacity-0 -translate-y-1/2"
              class="shadow-lg relative dark:bg-[#24232e] w-full min-h-[100px] flex-col mt-6 rounded-md bg-gray-50 px-6 py-5 sm:flex sm:items-start sm:justify-between"
            >
              <h2 class="text-sm font-bold dark:text-white">
                {{ t("input.uploadedd") }}
              </h2>
              <ul class="w-full mt-4">
                <FileList
                  :application="id"
                  v-for="(f, i) in item"
                  :display="cleanFile(f?.name, i)"
                  @delete="deleteFile"
                  type="af"
                  :key="f.id"
                  :id="f.id"
                  :item="f"
                />
              </ul>

              <a
                @click.stop.prevent="show = !show"
                class="inline-block text-white hover:text-fire trans absolute top-[-10px] right-[-48px] w-[62px] cursor-pointer"
              >
                <span
                  class="inline-flex justify-center items-center w-[26px] h-[26px] rounded-full bg-[#dedede] dark:bg-[#31313b] dark:text-white"
                  >X</span
                >
              </a>
            </TransitionRoot>
          </li>
        </ul>

        <!-- Upload documents -->
        <div
          class="mt-12 mb-24 w-full rounded-[12px] py-6 px-6 dark:bg-[#2e2d38] bg-white pr-4"
        >
          <h2 class="mb-4 text-xl font-bold dark:text-white">
            {{ t("dashboard.upload-doc") }}
          </h2>
          <div>
            <FileTypes class="mb-6" @updated="onFileTypeUpdate" />
            <file-pond
              class="cursor-pointer"
              name="request-file-upload"
              ref="pondUpload"
              :label-idle="t('drop')"
              :allow-multiple="true"
              accepted-file-types="application/pdf"
              credits="{}"
              @init="handleFilePondInit('general')"
            />
            <button
              @click="complete"
              type="button"
              class="w-full inline-block text-center bg-gradient-to-r from-[#ff000e] via-[#ff241d] to-[#ff602b] min-h-[52px] px-6 py-2 rounded-[24px] text-white mt-4 transition transition-blob"
            >
              {{ t("complete") }}
            </button>
          </div>
        </div>
        <!--# Upload documents -->
      </div>
    </div>
    <div class="absolute z-40 top-4 right-4">
      <button
        @click="$emit('close')"
        class="inline-flex text-white hover:text-fire trans font-bold outline transition-all text-sm justify-center items-center bg-[#dedede] dark:bg-[#31313b] w-[32px] h-[32px] rounded-full"
      >
        X
      </button>
    </div>
  </div>
</template>

<script>
import {
  CheckIcon,
  DotsVerticalIcon,
  PencilIcon,
  TrashIcon,
  PlusIcon,
  MinusIcon,
} from "@heroicons/vue/solid";
import { reactive, ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";

import { TransitionRoot } from "@headlessui/vue";

import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import vueFilePond, { setOptions } from "vue-filepond";
import FileList from "./inputs/FileList";
import FileTypes from "./inputs/FileTypes";

const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: "AllDocuments",
  components: {
    FileTypes,
    FileList,
    FilePond,
    CheckIcon,
    PencilIcon,
    DotsVerticalIcon,
    TrashIcon,
    TransitionRoot,
    PlusIcon,
    MinusIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const current = ref(0);
    const pond = ref(null);
    const pondUpload = ref(null);
    const currentItem = ref([]);
    const uploadType = ref({});
    const state = reactive({
      show: false,
    });
    const { t } = useI18n();

    const showFile = async (item) => {
      currentItem.value = item;
      state.show = !state.show;
    };

    const cleanFile = (f, i) => {
      return `${f.replace(/_file$/gi, "")}_${i + 1}`;
    };

    const fpUpload = async (
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort
    ) => {
      const { data } = await axios.post("/assets/signed");
      const headers = data.headers;
      const options = {
        headers,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          progress(percentCompleted, progressEvent.loaded, progressEvent.total);
        },
      };
      await axios.put(data.signedUrl, file, options);

      await axios.patch(`/applications/${props.id}/files`, {
        id: currentItem.value.id,
        key: data.key,
      });

      load(data.key);

      // Should expose an abort method so the request can be cancelled
      return {
        abort: () => {
          // Let FilePond know the request has been cancelled
          abort();
        },
      };
    };

    const fpRevert = async (uniqueFileId, load) => {
      await axios.delete(`/applications/${props.id}/files`, {
        headers: {},
        data: {
          id: currentItem.value.id,
          key: uniqueFileId,
        },
      });

      const objIndex = props.items.findIndex(
        (obj) => obj.id === currentItem.value.id
      );
      props.items.splice(objIndex, 1);

      load();
    };

    const fpUploadGeneral = async (
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort
    ) => {
      const { data } = await axios.post("/assets/signed");
      const headers = data.headers;
      const options = {
        headers,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          progress(percentCompleted, progressEvent.loaded, progressEvent.total);
        },
      };
      await axios.put(data.signedUrl, file, options);

      const res = await axios.patch(`/applications/${props.id}/files/upload`, {
        value: data.key,
        id: uploadType.value.id,
        key: uploadType.value.key,
      });

      currentItem.value.file = res.data.file;

      emit("update");

      load(data.key);

      // Should expose an abort method so the request can be cancelled
      return {
        abort: () => {
          // Let FilePond know the request has been cancelled
          abort();
        },
      };
    };

    const fpRevertGeneral = async (uniqueFileId, load) => {
      /*await axios.delete('/applications/files', {
                            headers: {},
                            data: {
                                id: currentItem.value.id,
                                key: uniqueFileId
                            }
                        })

                        const objIndex = props.items.findIndex((obj => obj.id === currentItem.value.id));
                        props.items.splice(objIndex, 1)*/

      load();
    };

    const handleFilePondInit = (section) => {
      if (section === "general") {
        setOptions({
          /*allowPdfPreview: true,
                                        pdfPreviewHeight: 600,
                                        pdfComponentExtraParams: 'toolbar=0&view=fit&page=1',*/
          server: {
            process: fpUploadGeneral,
            revert: fpRevertGeneral,
          },
        });
      } else {
        setOptions({
          /*allowPdfPreview: true,
                                        pdfPreviewHeight: 600,
                                        pdfComponentExtraParams: 'toolbar=0&view=fit&page=1',*/
          server: {
            process: fpUpload,
            revert: fpRevert,
          },
        });
      }

      /*setOptions({
                            allowPdfPreview: true,
                            pdfPreviewHeight: 600,
                            pdfComponentExtraParams: 'toolbar=0&view=fit&page=1'
                        }*/
    };

    const deleteFile = async ({ id }) => {
      try {
        await axios.delete(`/applications/${props.id}/files/single`, {
          headers: {},
          data: { id },
        });

        emit("update");
        const objIndex = props.items.findIndex(
          (obj) => obj.id === currentItem.value.id
        );
        if (objIndex) {
          const f = props.items[objIndex]?.file;
          const i = f.findIndex((o) => o === key);
          f.splice(i, 1);
        }
      } catch (e) {}
    };

    const fetchFile = async (obj) => {
      obj.editing = !obj.editing;
      currentItem.value = obj;
      let url = "";
      switch (obj.type) {
        case "f4037en":
          url = process.env.MIX_APP_F4037EN;
          break;
        case "f4037fr":
          url = process.env.MIX_APP_F4037FR;
          break;
        case "f4025en":
          url = process.env.MIX_APP_F4025EN;
          break;
        case "f4025fr":
          url = process.env.MIX_APP_F4025FR;
          break;
      }
      window.open(url);
    };

    const onFileTypeUpdate = (obj) => {
      uploadType.value = obj;
    };

    const complete = () => {
      window.location.href = `/applications/${props.id}`;
    };

    return {
      deleteFile,
      complete,
      cleanFile,
      currentItem,
      pond,
      pondUpload,
      fetchFile,
      handleFilePondInit,
      ...toRefs(state),
      showFile,
      t,
      onFileTypeUpdate,
      current,
    };
  },
};
</script>
<style>
.filepond--drop-label label {
  cursor: pointer !important;
}
</style>
